import { useRoute } from 'vue-router'
import ConfigManager from '@/config/ConfigManager.js'

export function useTheme() {
    let route = useRoute()
    let appName = route.query.appname
    let urlcssTheme = ConfigManager.getBlobUrl() + `/webconfig/landing/iimmpact/${appName}/theme.css`

    let cssId = 'iimmpact-theme'
    if (!document.getElementById(cssId)) {
        let head = document.getElementsByTagName('head')[0];
        let link = document.createElement('link');
        link.id = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = urlcssTheme;
        head.appendChild(link);
    }

    return {}
}
